module.exports = __webpack_public_path__ + "media/resume_rev/resume-rev-video-card-images-02-aab35d0b.jpg";